import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// styles
import styles from "../styles.module.css";

// constants
import { FIRST_STEP_DESCRIPTION, FIRST_STEP_HEADER } from "../constants";
import { OnboardingType } from "../onboarding";
import classNames from "classnames";

interface Props {
  type: OnboardingType;
}

const First: React.FC<Props> = ({ type = OnboardingType.LARGE }: Props) => {
  return (
    <Box className={styles.container}>
      <Box
        className={classNames(
          styles.image_wrapper,
          type === OnboardingType.SMALL && styles.image_wrapper_smaller
        )}>
        <Box component="img" src="/assets/images/onboarding-one.png" />
      </Box>
      <Box className={styles.text_wrapper}>
        <Typography
          className={classNames(
            styles.onboardingText,
            type === OnboardingType.SMALL && styles.onboardingSmaller
          )}
          variant="h1">
          {FIRST_STEP_HEADER}
        </Typography>
        {type === OnboardingType.LARGE && (
          <Typography className={styles.onboardingText} variant="body1">
            {FIRST_STEP_DESCRIPTION}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default First;
